module.exports = __webpack_public_path__ + "Flag-894.f946652b8824439fb4de82c902c1cc70.svg";